import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from "@apollo/client";
import { Loading } from '@website2018/da-dobsonville';
import Article from '../../components/Newsroom/Article';
import MetaHeader from '../../components/Meta/MetaHeader';
import { Redirect } from 'react-router-dom';

class PostContainer extends React.Component {
  render() {
    const { loading, mn, taxonomy, error } = this.props;
    if (loading) return <Loading/>;
    if (error || !mn) return <Redirect to={'/not-found'}/>;


    return ([
      <MetaHeader p={mn} />,
      <Article post={mn} taxonomy={taxonomy}/>
    ]);

  }
}

const POST_QUERY = gql`
  query getPost($slug: String!, $taxInput: TaxInputQuery) {
    mn(slug:$slug) {
      id
      formattedDate
      seo
      title {
        rendered
      }
      excerpt {
        rendered
      }
      content {
        rendered
      }
      featured_media {
        id
        source_url
  			title {
  			  rendered
  			}
      }
      category {
        id
        slug
        taxonomy
        name
      }
      meta {
        person {
          member
          role
          hasMember
        }
      }
    }
    taxonomy(input:$taxInput) {
      id
      name
      slug
      taxonomy
    }
  },

`;

const withPost = graphql(POST_QUERY, {
  options: (props) => ({
    variables: { slug: props.match.params.slug, taxInput: { taxonomy: 'categories' } }
  }),
  props: ({ data, post }) => ({ ...data }),
});

export default withPost(PostContainer);
